import { render, staticRenderFns } from "./WorkspaceDocuments.vue?vue&type=template&id=fa42c28c&scoped=true"
import script from "./WorkspaceDocuments.vue?vue&type=script&lang=js"
export * from "./WorkspaceDocuments.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceDocuments.vue?vue&type=style&index=0&id=fa42c28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa42c28c",
  null
  
)

export default component.exports